import { FC } from "react";
import { Col, Empty, Pagination, Skeleton, Table as AntTable } from "antd";
import "./gradeTable.less";

interface ITable {
  data: any[];
  columns: any[];
  onRowClick?: (record: any) => any | void;
  locale?: any;
  isLoading?: boolean;
  page?: number;
  pagination?: boolean;
  onChangePage?: React.Dispatch<React.SetStateAction<number>>;
  onPageSizeChange?: React.Dispatch<React.SetStateAction<number>>;
  count?: number;
  scroll?: number;
  scrollY?: number;
  uniqueClass?: string; // Add a uniqueClass prop
  customStyles?: string; // Add a uniqueClass prop
  onTableChange?: (pagination: any, filters: any, sorter: any) => void;
}

const Table: FC<ITable> = ({
  columns,
  data,
  onRowClick,
  pagination = false,
  isLoading,
  page = 1,
  count = 10,
  onChangePage,
  locale,
  scroll,
  scrollY,
  uniqueClass = "gradeTable", // Default to empty if not provided
  customStyles,
  onPageSizeChange,
  onTableChange,


}) => {
  const handlePageSizeChange = (current: number, pageSize: number) => {
    // ✅ Page size change pe page number 1 pe reset karo
    onChangePage?.(1);
    onPageSizeChange?.(pageSize);
  };
  const step = 10;
  const ensureSize = Math.max(step, Math.ceil(count / step) * step);
  const pageSizeOptionsArr = Array.from({ length: ensureSize / step }, (_, i) =>
    String((i + 1) * step)
  );

  return (
    <Col span={24}>
      <div className={`${customStyles}`}>
        <AntTable
          onRow={(record: any) => ({
            onClick: () => onRowClick && onRowClick(record),
          })}
          className={`table ${uniqueClass} ${onRowClick ? "onRowHover" : ""} ${window.location.pathname.includes("client") && "table--client"
            }`}
          // scroll={{ x: scroll || "100%", y: scrollY || "100%" }}

          scroll={{ x: "max-content", y: 400 }}
          columns={columns}
          onChange={onTableChange}
          dataSource={isLoading ? [] : data}
          pagination={false}
          rowKey="id"
          locale={
            !data?.length && !isLoading
              ? locale
              : {
                emptyText: isLoading ? (
                  <>
                    {[1, 2, 3, 4].map(x => (
                      <Skeleton.Input key={x} size="small" active={true} />
                    ))}
                  </>
                ) : (
                  <Empty />
                ),
              }
          }
        />
        {data?.length && pagination ? (
          <div className="table__pagination">
            <Pagination
              onChange={onChangePage}
              current={page}
              defaultCurrent={1}
              total={count}
              showSizeChanger
              onShowSizeChange={handlePageSizeChange}
              pageSizeOptions={["10", "20", "50", "100"]}
            />
          </div>
        ) : null}
      </div>
    </Col>
  );
};

export default Table;
